import { render, staticRenderFns } from "./BusinessDetailV2.vue?vue&type=template&id=df4a9918&scoped=true"
import script from "./BusinessDetailV2.vue?vue&type=script&lang=js"
export * from "./BusinessDetailV2.vue?vue&type=script&lang=js"
import style0 from "./BusinessDetailV2.vue?vue&type=style&index=0&id=df4a9918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4a9918",
  null
  
)

export default component.exports